import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('banks');
